import React, { createContext, useContext } from 'react'
import { ModalProps } from '../components/Modal'
export interface FormProps<T, K = unknown> {
  initialValue?: Partial<T>
  extras: K
  onSubmit: (data: T) => void
  onAbort?: () => void
  onError?: () => void
}

export type FormRenderer = <T, K>(
  component: React.FC<FormProps<T, K>>,
  submitHandler?: (data: T) => Promise<{ ok: boolean }>,
  initialValue?: Partial<T>,
  extras?: K,
  modalProps?: Omit<ModalProps, 'children'>
) => Promise<UseFormReturn<T>>

export type UseFormReturn<T> =
  | { status: 'success'; data: T }
  | { status: 'error' }
  | { status: 'aborted' }

export interface UseFormProps<T, K> {
  formComponent: React.FC<FormProps<T, K>>
  extras?: K
}

export const FormContext = createContext<{
  formRenderer: FormRenderer
  isLoading: boolean
} | null>(null)

export const useFormRenderer = () => {
  const ctx = useContext(FormContext)
  if (!ctx) throw new Error('useForm must be used within a FormProvider')
  return ctx
}
